import type { SVGProps } from 'react';
const DawnFlagBR = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-BR_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-BR_svg__a)">
      <path fill="#05AB41" d="M0 0h22v16H0z" />
      <path
        fill="#FDD216"
        fillRule="evenodd"
        d="M2.94 8.557a.667.667 0 0 1 0-1.114l7.694-5.068a.67.67 0 0 1 .733 0l7.693 5.068c.4.264.4.85 0 1.114l-7.693 5.068a.67.67 0 0 1-.733 0z"
        clipRule="evenodd"
      />
      <path
        fill="#053087"
        fillRule="evenodd"
        d="M11 11.733c2.025 0 3.666-1.671 3.666-3.733S13.025 4.267 11 4.267 7.333 5.938 7.333 8 8.975 11.733 11 11.733"
        clipRule="evenodd"
      />
      <mask
        id="dawn-flag-BR_svg__b"
        width={8}
        height={8}
        x={7}
        y={4}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M11 11.733c2.025 0 3.666-1.671 3.666-3.733S13.025 4.267 11 4.267 7.333 5.938 7.333 8 8.975 11.733 11 11.733"
          clipRule="evenodd"
        />
      </mask>
      <g mask="url(#dawn-flag-BR_svg__b)">
        <path
          fill="#fff"
          fillRule="evenodd"
          d="m7.32 7.543-.51.42-.85-1.03.513-.424c.307-.253.703-.327 1.032-.347.349-.021.74.012 1.138.07.797.12 1.73.36 2.595.595.92.25 1.85.633 2.613 1.03a10 10 0 0 1 1.02.606c.28.194.543.409.719.63l.416.523-1.042.828-.416-.522c-.054-.068-.19-.194-.433-.363a8 8 0 0 0-.876-.52c-.69-.358-1.53-.704-2.346-.925-.868-.236-1.731-.456-2.44-.562a4.3 4.3 0 0 0-.861-.059c-.206.013-.272.05-.272.05"
          clipRule="evenodd"
        />
      </g>
    </g>
  </svg>
);
export default DawnFlagBR;
